import { createRef, useEffect, useState } from "react";

import { Button, StopSVG, VolumeUpSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import requestAudioFile from "../../ReadAloudControls/useReadAloudAudio/utils/requestAudioFile";
import { rootElementStyles } from "./StandaloneReadAloudButton.style";

const propTypes = {
  readAloudData: PropTypes.object,
  iconCss: PropTypes.object,
  buttonOverrideCss: PropTypes.object,
  text: PropTypes.string,
  eventProperties: PropTypes.object,
  powerWord: PropTypes.string,
  dataProps: PropTypes.object,
};
const ButtonWithTrackEvent = withTrackEvent(Button);

const StandaloneReadAloudButton = ({
  text = "",
  iconCss = {},
  buttonOverrideCss = {},
  eventProperties = {},
  powerWord,
  dataProps = {},
}) => {
  const [audioFile, setAudioFile] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const readAloudRef = createRef();
  const CurrentIcon = isPlaying ? StopSVG : VolumeUpSVG;

  const playReadAloud = () => {
    readAloudRef.current?.play();
    setIsPlaying(true);
  };

  const stopReadAloud = () => {
    readAloudRef.current?.pause();
    readAloudRef.current.currentTime = 0;
    setIsPlaying(false);
  };

  const onIconClick = !isPlaying ? playReadAloud : stopReadAloud;

  const onAudioEnded = () => {
    setIsPlaying(false);
  };

  const getAudioContents = async () => {
    const { data } = await requestAudioFile(text);
    setAudioFile(data?.download_url);
  };

  useEffect(() => {
    getAudioContents();
  }, [isPlaying]);

  return (
    <span css={rootElementStyles}>
      <ButtonWithTrackEvent
        ariaProps={{
          "aria-label": isPlaying
            ? `Stop ${powerWord} definition`
            : `Play ${powerWord} definition`,
        }}
        dataProps={dataProps}
        __cssFor={{
          root: buttonOverrideCss,
          Icon: { root: iconCss },
        }}
        icon={{
          SvgComponent: CurrentIcon,
          alignment: Button.iconAlignments.right,
        }}
        flavor={Button.flavors.tertiary}
        onClick={onIconClick}
        {...eventProperties}
      />
      <audio onEnded={onAudioEnded} ref={readAloudRef} src={audioFile} />
    </span>
  );
};

StandaloneReadAloudButton.propTypes = propTypes;

export default StandaloneReadAloudButton;
